import swal from "sweetalert";
import i18next from "i18next";

const errorMsgs = {
  "api.amgapi.err.001": "unknown error",
  "api.amgapi.err.002": "token required",
  "api.amgapi.err.003": "something went wrong",
  "api.amgapi.err.004": "user already exists",
  "api.amgapi.err.005": "patient's firstname required",
  "api.amgapi.err.006": "patient's lastname required",
  "api.amgapi.err.007": "patient's birthday required",
  "api.amgapi.err.008": "invalid token",
  "api.amgapi.err.009": "invalid data",
  "api.amgapi.err.010": "patient not found",
  "api.amgapi.err.011": "name is required",
  "api.amgapi.err.012": "username is required",
  "api.amgapi.err.013": "password is required",
  "api.amgapi.err.014": "username not found",
  "api.amgapi.err.015": "invalid password",
  "api.amgapi.err.016": "username required",
  "api.amgapi.err.017": "lastname required",
  "api.amgapi.err.018": "role is required",
  "api.amgapi.err.019": "Username already taken",
  "api.amgapi.err.020": "email is required",
  "api.amgapi.err.021": "username must contain at least 3 characters",
  "api.amgapi.err.022": "password must contain at least 8 characters",
  "api.amgapi.err.023":
    "Verifier vos identifiants ou contacter votre administrateur",
  "api.amgapi.err.024": "missing consultation id",
  "api.amgapi.err.025": "missing patient id",
  "api.amgapi.err.026": "missing date",
  "api.amgapi.err.027": "missing duration",
  "api.amgapi.err.028": "this time slot is not free",
  "api.amgapi.err.029": "appointment not found",
  "api.amgapi.err.030": "contact not found",
  "api.amgapi.err.031": "invalid date",
  "api.amgapi.err.032": "missing generic name",
  "api.amgapi.err.033": "missing medicine atc code",
  "api.amgapi.err.034": "prescription not found",
  "api.amgapi.err.035": "duplicate  medicine  atc code",
  "api.amgapi.err.036": "medicine type is required",
  "api.amgapi.err.037": "medicine type not found",
  "api.amgapi.err.038": "medicine list type not found",
  "api.amgapi.err.039": "consultation not found",
  "api.amgapi.err.040": "care type not found",
  "api.amgapi.err.041": "bill not found",
  "api.amgapi.err.042": "no fund",
  "api.amgapi.err.043": "patient sexe is required",
  "api.amgapi.err.044": "analyses not found",
  "api.amgapi.err.045": "missing test name",
  "api.amgapi.err.046": "missing test code",
  "api.amgapi.err.047": "examinatiom not found",
  "api.amgapi.err.048": "gynrcological note not found",
  "api.amgapi.err.049": "order is already sent",
  "api.amgapi.err.050": "order has not been sent",
  "api.amgapi.err.051": "result not ready",
  "api.amgapi.err.052": "date is ",
  "api.amgapi.err.053": "access to silabmed is denied",
  "api.amgapi.err.054": "access to sysgestock is denied",
  "api.amgapi.err.055": "test code already exists",
  "api.amgapi.err.056": "care name required",
  "api.amgapi.err.057": "care code required",
  "api.amgapi.err.058": "insuficient privilege",
  "api.amgapi.err.059": "currency not found",
  "api.amgapi.err.060": "role not found",
  "api.amgapi.err.061": "unathorized operation",
  "api.amgapi.err.062": "abbr required",
  "api.amgapi.err.063": "token expired",
  "api.amgapi.err.064": "user not found",
  "api.amgapi.err.065": "info not founds",
  "api.amgapi.err.066": "nom du vaccin requis",
  "api.amgapi.err.067": "quantite de dose recu pris requis",
  "api.amgapi.err.068": "duplicate Patient Folder num",
  "api.amgapi.err.069": "dosage unit required",
  "api.amgapi.err.070": "dosage required",
  "api.amgapi.err.071": "missing medicine name",
  "api.amgapi.err.072": "medicine not found",
  "api.amgapi.err.073": "disease not found",
  "api.amgapi.err.074": "diagnostic not found",
  "api.amgapi.err.075": "medicament sku is required",
  "api.amgapi.err.076": "succursale not found",
  "api.amgapi.err.077": "invalid field type int json data",
  "api.amgapi.err.078": "no data submitted",
  "api.amgapi.err.079": "disease code required",
  "api.amgapi.err.080": "cannot deactivate succursale with employee",
  "api.amgapi.err.081": "patient is already being cared by a doctor",
  "api.amgapi.err.082": "doctor not found",
  "api.amgapi.err.083": "password not match",
  "api.amgapi.err.084": "password not strong",
  "api.amgapi.err.085": "country required",
  "api.amgapi.err.086": "invalid email",
  "api.amgapi.err.087": "business name required",
  "api.amgapi.err.088": "business domain required",
  "api.amgapi.err.089": "business not found",
  "api.amgapi.err.090": "invalid filters",
  "api.amgapi.err.091": "invalid sort",
  "api.amgapi.err.092": "already disabled",
  "api.amgapi.err.093": "already enabled",
  "api.amgapi.err.094": "old password incorrect",
  "api.amgapi.err.095": "tenant not found",
  "api.amgapi.err.096": "contact name required",
  "api.amgapi.err.097": "profile not found",
  "api.amgapi.err.098": "profile already exists",
  "api.amgapi.err.099": "business id required",
  "api.amgapi.err.100": "currency required",
  "api.amgapi.err.101": "seller profile required for creating business",
  "api.amgapi.err.102": "offer not found",
  "api.amgapi.err.103": "document not found",
  "api.amgapi.err.104": "invalid document type",
  "api.amgapi.err.105": "account not verified",
  "api.amgapi.err.106": "invalid rate",
  "api.amgapi.err.107": "cannot rate self",
  "api.amgapi.err.108": "rate not found",
  "api.amgapi.err.109": "invalid profile type",
  "api.amgapi.err.110": "report not found",
  "api.amgapi.err.111": "room not found",
  "api.amgapi.err.112": "message not found",
  "api.amgapi.err.113": "asking price required",
  "api.amgapi.err.114": "employees number required",
  "api.amgapi.err.115": "equity offered required",
  "api.amgapi.err.116": "invalid equity offered",
  "api.amgapi.err.117": "notification not found",
  "api.amgapi.err.118": "region required",
  "api.amgapi.err.119": "assets value required",
  "api.amgapi.err.120": "average monthly sales required",
  "api.amgapi.err.121": "phone required",
  "api.amgapi.err.122": "yearly sales required",
  "api.amgapi.err.123": "title required",
  "api.amgapi.err.124": "message required",
  "api.amgapi.err.125": "desclaimer acceptance required",
  "api.amgapi.err.126": "desclaimer identifier empty",
  "api.amgapi.err.127": "desclaimer identifier exist",
  "api.amgapi.err.128": "desclaimer not found",
  "api.amgapi.err.129": "desclaimer not accepted",
  "api.amgapi.err.130": "contract type not found",
  "api.amgapi.err.131": "contract type name required",
  "api.amgapi.err.132": "invalid base64 file",
  "api.amgapi.err.133": "contract type required",
  "api.amgapi.err.134": "contract name required",
  "api.amgapi.err.135": "contract signers required",
  "api.amgapi.err.136": "recipient name required",
  "api.amgapi.err.137": "recipient email required",
  "api.amgapi.err.138": "contract expiration date required",
  "api.amgapi.err.139": "recipient role required",
  "api.amgapi.err.140": "need to login to profile",
  "api.amgapi.err.141": "email already exists",
  "api.amgapi.err.142": "contract not found",
  "api.amgapi.err.143": "ebitda margin invalid",
  "api.amgapi.err.144": "history required",
  "api.amgapi.err.145": "history invalid",
  "api.amgapi.err.146": "duplicate year statement",
  "api.amgapi.err.147": "year statement not found",
  "api.amgapi.err.148": "excel not found",
  "api.amgapi.err.149": "template not found",
  "api.amgapi.err.150": "value cannot be negative",
  "api.amgapi.err.151": "occupation required",
  "api.amgapi.err.152": "template in use",
  "api.amgapi.err.153": "contact email required",
  "api.amgapi.err.154": "duplicate signer",
  "api.amgapi.err.155": "duplicate recipient",
  "api.amgapi.err.156": "file too large",
  "api.amgapi.err.157": "business not available",
  "api.amgapi.err.158": "cannot delete accepted offer",
  "api.amgapi.err.159": "cannot update accepted offer",
  "api.amgapi.err.160": "contract type name exist",
  "api.amgapi.err.161": "invalid status",
  "api.amgapi.err.162": "invalid job title",
  "api.amgapi.err.163": "professional domain required",
  "api.amgapi.err.164": "job description required",
  "api.amgapi.err.165": "job budget required",
  "api.amgapi.err.166": "job not found",
  "api.amgapi.err.167": "document data required",
  "api.amgapi.err.168": "cover letter too short",
  "api.amgapi.err.169": "job closed",
  "api.amgapi.err.170": "cannot choose yourself",
  "api.amgapi.err.171": "professional not applied",
  "api.amgapi.err.172": "signer email and name required",
  "api.amgapi.err.173": "currency already exists",
  "api.amgapi.err.174": "client not connected",
  "api.amgapi.err.175": "report classification required",
  "api.amgapi.err.176": "business already rated",
  "api.amgapi.err.177": "profession required",
  "api.amgapi.err.178": "profession invalid",
  "api.amgapi.err.179": "representative id required",
  "api.amgapi.err.180": "representative not found",
  "api.amgapi.err.181": "invalid role",
  "api.amgapi.err.182": "client already connected",
  "api.amgapi.err.183": "no assigned representative",
  "api.amgapi.err.184": "profession needed",
  "api.amgapi.err.185": "invalid image",
  "api.amgapi.err.186": "ip hidden",
  "api.amgapi.err.187": "entity id required in upload file",
  "api.amgapi.err.188": "entity required in upload file",
  "api.amgapi.err.189": "file name required",
  "api.amgapi.err.190": "invalid entity",
  "api.amgapi.err.191": "key required",
  "api.amgapi.err.192": "file type required",
  "api.amgapi.err.193": "file not found",
  "api.amgapi.err.194": "invalid file type",
  "api.amgapi.err.195": "file already exists",
  "api.amgapi.err.196": "note content required",
  "api.amgapi.err.197": "note title required",
  "api.amgapi.err.198": "invalid authorized party",
  "api.amgapi.err.199": "key of file is empty",
  "api.amgapi.err.200": "unsupported file type",
  "api.amgapi.err.201": "note not found",
  "api.amgapi.err.202": "owner name required",
  "api.amgapi.err.203": "owner type required",
  "api.amgapi.err.204": "owner type invalid",
  "api.amgapi.err.205": "owner equity invalid",
  "api.amgapi.err.206": "owner equity sum invalid",
  "api.amgapi.err.207": "files limit reached",
  "api.amgapi.err.208": "no representative available",
  "api.amgapi.err.209": "file size limit exceed",
  "api.amgapi.err.210": "invalid subinterest format",
  "api.amgapi.err.211": "invalid content format",
  "api.amgapi.err.212": "invalid subject format",
  "api.amgapi.err.213": "invalid event type format",
  "api.amgapi.err.214": "invalid language format",
  "api.amgapi.err.215": "invalid media format",
  "api.amgapi.err.216": "invalid media type format",
  "api.amgapi.err.217": "invalid workflow name format",
  "api.amgapi.err.218": "invalid work flow category",
  "api.amgapi.err.219": "invalid work flow node type",
  "api.amgapi.err.220": "work flow id required",
  "api.amgapi.err.221": "workflow node position required",
  "api.amgapi.err.212": "work flow node required",
  "api.amgapi.err.213": "work flow node rule type required",
  "api.amgapi.err.214": "invalid work flow node rule type",
  "api.amgapi.err.215": "work flow node rule name required",
  "api.amgapi.err.216": "work flow node rule parent node id required",
  "api.amgapi.err.217": "invalid work flow node rule type",
  "api.amgapi.err.218": "work flow node rule parent node id required",
  "api.amgapi.err.219": "invalid work flow node rule type",
  "api.amgapi.err.220": "invalid business progress note",
  "api.amgapi.err.221": "invalid business progress note type",
  "api.amgapi.err.222": "invalid business progress note language",
  "api.amgapi.err.223": "invalid business progress note language",
  "api.amgapi.err.224": "invalid business progress note language"


};
function formatError(errorResponse) {
  swal({
    title: "Oops",
    text:
      i18next.t(errorResponse) ||
      errorMsgs?.[errorResponse] ||
      i18next.t("herror"),
    icon: "error",
    button: i18next.t("htry"),
  });
}

export default formatError;
